export const allMenuItems = [
  {
    id: 1,
    href: "inicio",
    nombre: "Inicio",
    icon: "fas fa-home",
    subMenus: [],
  },
  {
    id: 2,
    href: "agenda",
    nombre: "Agenda",
    icon: "fas fa-calendar",
    subMenus: [],
  },
  {
    id: 3,
    href: "fichajes",
    nombre: "Fichajes",
    icon: "fas fa-clock",
    subMenus: [],
  },
  {
    id: 4,
    href: "gastos",
    nombre: "Gastos",
    icon: "fas fa-money-bill-wave",
    subMenus: [],
  },
  {
    id: 5,
    href: "transporte",
    nombre: "Transporte",
    icon: "fas fa-bus",
    subMenus: [],
  },
  {
    id: 6,
    href: "mensajeria",
    nombre: "Mensajería",
    icon: "fas fa-comment-dots",
    subMenus: [],
  },
  {
    id: 7,
    href: "gerencia",
    nombre: "Gerencia",
    icon: "fas fa-user-tie",
    subMenus: [],
  },
  {
    id: 8,
    href: "pedido-interno",
    nombre: "Pedido Interno",
    icon: "fas fa-clipboard-list",
    subMenus: [],
  },
  /*
  {
    id: 4,
    href: "clientes",
    nombre: "Clientes",
    icon: "fas fa-users",
    subMenus: [],
  },
  */
];
